<template>
    <main>
      <section class="section">
        <div class="container container--medium">
          <div class="grid">
            <div>
              <h5 class="heading-xtra-sub">Buy directly from us</h5>
              <h3 class="heading-xtra">MNC Play TV AddOn </h3>
              <!-- <div class="bottom-solid pb-20 mb-1">
                <h4 class="heading mb-1">Fill your information</h4>
                <input :class="`input ${msgError? 'input--failed' : ''}`" placeholder="SN STB/ ID Pelanggan/ No HP" type="number" v-model="idPelanggan">
               
               
              </div> -->
              <template>
              <main v-if="!isPromoAvailable">
                <!-- konten utama -->
                <div>
                 <div class="box-premium" style="margin-bottom:20px;">
                    <div class="bottom-dashed pb-20 mb-1">
                      <div v-if="id">
                        <h4 class="heading heading--user">Nama : {{ nama }}</h4>
                        <p class="heading--user-desc">Customer ID :  {{ id }}</p>
                        <p class="heading--user-desc">Email : {{ email }}</p>
                      </div>
                      <h4 v-else class="heading weight-700">User</h4>
                    </div>
                    <div class="bottom-dashed pb-20 mb-1">
                      <h4 class="heading">Invoice</h4>
                      <div v-if="id && productDetail">
                        <ul class="list list--invoice">
                          <li>
                            <p>{{ productDetail.productname }}</p>
                            <p>{{ rpFormat(productDetail.price) }}</p>
                          </li>
                          <li>
                            <p>PPN</p>
                            <p>{{ rpFormat(productDetail.ppn) }}</p>
                          </li>
                          <li v-if="productDetail.admin_fee">
                            <p>Admin</p>
                            <p>{{ rpFormat(productDetail.admin_fee) }}</p>
                          </li>
                        </ul>
                        <div class="heading--total">
                          <p>Total</p>
                          <p>{{ rpFormat(productDetail.price_final) }}</p>
                        </div>
                      </div>
                      <p v-else>-</p>
                    </div>
                    <div v-if="showQris" class="text-center">
                    <img v-bind:src="imageqris">
                    <br>
                    <a class="button button--submit" style="margin: 2px 0px 5px;
        border-radius: 10px;
        width: 170px;
        font-size: 15px;" v-bind:href="imageqris" download="qris-addon.png">Download QRIS</a>
                  </div>
                    <div>
                      <a :class="`button button--submit ${id && !qrsIsLoading ? '' : 'disabled'} text-center`"  @click="checkoutqris">
                        <div v-if="qrsIsLoading" class="loader"></div>
                        <template v-else>Bayar QRIS</template>
                      </a>
                    </div>
                  </div>
                  </div>
              </main>
              <div v-else class="text-center mt-5">
                <div>
                 <div class="box-premium" style="margin-bottom:20px;">
                  <div class="bottom-dashed pb-20 mb-1">
                    Pelanggan sudah berlangganan paket <strong>Timnas Package</strong>
                  </div>
                </div>
                </div>
              </div>
            </template>
             
              <div>
              <p class="text-danger" style="color:red">
                <span >* Paket ini merupakan paket tambahan (Add-on).</span><br>
                <span>* Pastikan tagihan Indosat Hifi anda sudah terbayar.</span>
                
              </p>
              <ol class="vision-instructions">
                <li>Download aplikasi <strong>Vision+</strong> di HP/tablet/android box/smart TV Anda melalui Google Play atau Apple Store.</li>
                <li>Masukkan <strong>username</strong> dengan alamat email yang terdaftar di IOH dan menerima pesan promo.</li>
                <li>Klik <strong>“Forgot Password”</strong> dan masukkan password yang dikehendaki atau  <strong>"Continue With OTP"</strong>.</li>
                <li>Login kembali di aplikasi Vision+ dengan email dan password baru Anda.</li>
                <li>Anda dapat menikmati tayangan Vision+ dengan email dan password yang sama di <strong>2 device yang berbeda secara bersamaan</strong>.</li>
              </ol>

              <p class="vision-instructions"><strong>Selamat Menikmati Pertandingan Olahraga Kelas Dunia di Vision+</strong></p>
                
             <p> Bukan pelanggan MNC Play? Nikmati aksi Timnas di layar lebar! Tonton melalui OTT V+ dengan Android Box Vision+ TV. </p>
             <p>
Tersedia di Tokopedia, Shopee, dan Blibli.
Klik disini 
<a href="https://www.visionplustv.id/marketplace">https://www.visionplustv.id/marketplace</a>
             </p>
             <p>
Untuk berlangganan MNC Play Hifi Indosat hubungi : 02130001515
</p>
            </div>
            </div>
            <div>

            </div>
          </div>
        </div>
      </section>
  
      <div :class="`modal-mobile ${durationSelected? 'active detail-active' : ''}`">
        <div class="close-modal" @click="() => {durationSelected = null; bodyClass.remove('scroll-hidden-mobile')}"></div>
        <div class="contents box-mobile">
          <!-- <div class="line-top mb-1"></div> -->
          <div :class="`detail`">
            <div class="mb-1">
              <div v-if="user">
                <h4 class="heading--user-desc">{{ user.fullname }}</h4>
                <p class="heading--user-desc">Customer ID {{ user.customerid }}</p>
                <p class="heading--user-desc">SN {{ user.sn }}</p>
              </div>
            </div>
            <div class="mb-1">
              <h4 class="heading">Payment Details</h4>
              <ul class="list list--invoice">
                <li>
                  <p>{{ removeNumber(durationSelected && durationSelected.productname) }} {{ totalMonth(durationSelected && durationSelected.age) }}</p>
                  <p>{{ rpFormat(durationSelected && durationSelected.price) }}</p>
                </li>
              </ul>
            </div>
            
          </div>
          <div class="grid grid--fix-two">
            <div>
              <p class="heading--user-desc"><b>Total</b> <span>(1 item)</span></p>
              <p class="heading--total">{{ rpFormat(durationSelected && durationSelected.price) }}</p>
            </div>
            <a class="button button--submit text-center" @click="checkout">
              <div v-if="isLoading" class="loader"></div>
              <template v-else>Bayar</template>
            </a>
          </div>
        </div>
      </div>
  
      <!-- Pop up didn't use -->
      <div :class="`modal ${popUp? 'active' : ''}`">
        <div class="close-modal" @click="popUp = !popUp"></div>
        <div class="contents box-alert">
          <img class="close" src="@/assets/images/icons/close.svg" alt="close button" @click="popUp = !popUp">
          <!-- <div class="text-center mb-2">
            <img class="icon" src="@/assets/images/icons/success.svg" alt="">
            <h3 class="head-alert success">Pembayaran Berhasil</h3>
          </div> -->
          <div class="text-center mb-2">
            <img class="icon" src="@/assets/images/icons/failed.svg" alt="">
            <h3 class="head-alert failed">Pembayaran Gagal</h3>
          </div>
          <div class="mb-half-1">
            <h4 class="heading--user-desc">Details</h4>
            <p class="heading--user-desc">Customer ID 2100000778</p>
            <p class="heading--user-desc">SN 19102600003344</p>
          </div>
          <div class="mb-half-1">
            <h4 class="heading--user-desc">Transfer Amount</h4>
            <p class="heading--user-desc">Rp. 360.000</p>
          </div>
          <div>
            <h4 class="heading--user-desc">Tanggal Pembayaran</h4>
            <p class="heading--user-desc">Jumat, 23 November 2021 19:20</p>
          </div>
          <div class="mt-2">
            <a class="button button--submit text-center" href="javascript:void(0)">Coba Lagi</a>
          </div>
        </div>
      </div>
    </main>
  </template>
  
  <script>
  import axios from 'axios'
  // import vouchers from '../json/vouchers'
  // import packages from '../json/packages'
  
  export default {
    name: 'Home-backup',
    data () {
      return {
        isPromoAvailable: null,
        isLoading: false,
        bodyClass: null,
        idPelanggan: null,
        idPelTemp: null,
        msgError: '',
        user: null,
        listUser: [],
        imageqris: null,
        showQris:false,
        qrsIsLoading: false,
        optionSelected: null,
        packageSelected: null,
        durationSelected: null,
        paymentSelected: null,
        productDetail: null,
        options: [
          {
            id: 3,
            title: 'Premium Channel Package',
            desc: 'From movies to sports, subscribe to numerous Premium Channels in affordable packages!'
          },
          {
            id: 8,
            title: 'Video Streaming Voucher',
            desc: 'Your favorite video streaming platform is here, check the voucher and watch now!'
          }
        ],
        packages: [],
        durations: [],
        popUp: false,
        detail: false
      }
    },
    watch: {
      idPelanggan (event) {
        setTimeout(() => {
          if (this.idPelanggan && this.idPelanggan !== this.idPelTemp) this.reset()
          this.idPelTemp = event
          if (this.idPelanggan === this.idPelTemp && this.idPelTemp.length > 5) {
            this.getUser()
          } else if (this.idPelanggan.length === 0) {
            this.reset()
            this.msgError = 'You must fill this first'
          }
        }, 300)
      }
    },
    computed: {
      labelOption () {
        let label = 'Package/Voucher'
        if (this.optionSelected === 3) {
          label = 'Package'
        } else if (this.optionSelected === 8) {
          label = 'Voucher'
        }
        return label
      },
      id() {
        return this.$route.query.id;
        },
    nama() {
        return this.$route.query.nama;
        },
    email() {
        return this.$route.query.email;
        },
    stbtype() {
    return this.$route.query.stbtype;
    }    
    },
    methods: {
      async checkPromoTimnas () {
        const query = this.$route.query
        //this.idPelTemp = await query.customerid
        try {
          const params = {
                        accountid: await query.id,
                        email: await query.email,
                        serviceid: "indosathifi_x_vision_ps",
                        
                    }

          //const res = await axios.post('http://pembayaran-api-dev.mncplaymedia.com/api/check_promo_timnas')
          //const res = await axios.post('http://localhost:8888/webpurchase/actionplays/checkpackage', params)
          const res = await axios.post('https://b2b-api.mncplay.id/frontend/web/index.php/webpurchase/actionplays/checkpackage', params)

          this.isPromoAvailable = res.data.status
        } catch (error) {
          console.error('Error checking promo:', error)
          this.isPromoAvailable = false
        }
      },
      async checkout () {
        if (!this.durationSelected || this.isLoading) return
  
        this.isLoading = true
        const params = { ID: this.durationSelected.productcode, CID: this.user.customerid }
        try {
          const res = await axios.post(`/checkout`, params)
          if (!res.data.status) {
            this.isLoading = false
            alert(res.data.data.message)
            return
          }
          this.$ga.event('Payment', 'select_package', 'Select Package', this.packageSelected.productgroup)
          this.$ga.event('Payment', 'select_duration', 'Select Duration', this.durationSelected.productcode)
          this.$ga.event('Payment',  'checkout', 'Checkout', 'success')
          this.postWaNotif(res.data.data)
        } catch (error) {
          console.log(error)
          this.isLoading = false
        }
      },
      async checkoutqris () {
       
        this.qrsIsLoading = true
       
        const params = {
                        accountid: this.id,
                        terminal_id: "Fm_Qris_Mnc",
                        amount: this.productDetail.price_final,
                        description: "Description of transaction",
                        fullname: this.nama,
                        email: this.email,
                        //email: 'dummy@email.com',
                        phone_number: '-',
                        stbtype : this.stbtype,
                       // service_id: "VP_SUBS_SPRTS_PKG",
                        service_id: this.productDetail.provisioningcode,
                        //productcode : "VP_SUBS_SPRTS_PKG",
                        productcode : this.productDetail.provisioningcode,
                        //provisioningcode : "VP_SUBS_SPRTS_PKG",
                        provisioningcode : this.productDetail.provisioningcode,
                        m_jenisproduct_id : 2
                        
                    }
            try {
                const res = await axios.post(`https://b2b-api.mncplay.id/frontend/web/index.php/webpurchase/actionplays/qrisorder`, params)
                //const res = await axios.post(`qrisorder`, params)
                
                if (!res.data.status) {
                this.qrsIsLoading = false
                alert(res.data.data.message)
                return
                }

                this.showQris = true;
                this.imageqris = res.data.qris;
                //console.log(this.imageqris);
                this.qrsIsLoading = false;
                
            } catch (error) {
                console.log(error)
                this.qrsIsLoading = false
            }
        },
      async postWaNotif (data) {
        const params = {
          customer_id: data.account_id,
          paketname: data.paketname,
          sn: data.sn,
          price: data.price,
          nohp: data.nohp
        }
        try {
          await axios.post(`/wanotif`, params)
          this.isLoading = false
          window.location.href = `https://b2b-api.mncplay.id/billmain.php?CID=${data.account_id}`
        } catch (error) {
          console.log(error)
          this.isLoading = false
        }
      },
      reset (delUser = true) {
        if (delUser) {
          this.user = null
          this.listUser = []
        }
        this.optionSelected = null
        this.packageSelected = null
        this.durationSelected = null
        this.paymentSelected = null
        this.packages = []
        this.durations = []
      },
      selectUser (val) {
        this.user = val
        this.reset(false)
      },
      choose (type, val) {
        console.log(val);
        if (!this.user || this.user.is_isp === 1) return
  
        if (this.bodyClass.contains('scroll-hidden-mobile')) this.bodyClass.remove('scroll-hidden-mobile')
  
        if (type === 'option') {
          this.optionSelected = val
          this.packageSelected = null
          this.durationSelected = null
          this.paymentSelected = null
          this.durations = []
          this.getListAddOns()
        } else if (type === 'package') {
          this.packageSelected = val
          // this.$ga.event('Payment', 'select_package', 'Select Package', val.productgroup)
          this.durations = val.durations
          this.durations.sort((a,b) => {
            return a.age - b.age
          })
          this.durationSelected = null
          this.paymentSelected = null
        } else if (type === 'duration') {
          this.durationSelected = val
          this.bodyClass.add('scroll-hidden-mobile')
          // this.$ga.event('Payment', 'select_duration', 'Select Duration', val.productcode)
          this.paymentSelected = null
        } else if (type === 'payment') {
          this.paymentSelected = val
        }
      },
      totalMonth (val) {
        let total = val / 30
        return `${total} ${total > 1? 'Months': 'Month'}`
      },
      rpFormat (val) {
        if (!val) return
        if (val !== parseInt(val, 10)) {
          let valTemp = (Math.round(val * 100) / 100).toString().split('.')
          return `Rp. ${valTemp[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")},${valTemp[1]}`
        }
  
        return `Rp. ${val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")}`
      },
      removeNumber (val) {
        if (val) return val.split(/[0-9]/g)[0].trim()
      },
      async getProductAddon() {
      try {
        const prod = this.$route.query.prod || 'sport'; // fallback jika tidak ada
        const response = await axios.get(`https://iptvapi.mncplay.id/api/get-product-addon?prod=${prod}`);
        
        // Sesuaikan format response dengan struktur data kamu
        //this.packages = response.data.data || []; // asumsikan response.data.data adalah array paket
        if (response.data && response.data.data && response.data.data.length > 0) {
          this.productDetail = response.data.data[0];
        }
      } catch (error) {
        console.error('Error fetching addon products:', error);
        this.packages = [];
      }
    },
   
    },
   
    async mounted () {
      // https://mvn-web-purchase.web.app?customerid=2100000150&producttype=3&productcode=VPPremium30
      this.bodyClass = document.getElementsByTagName('body')[0].classList

      //await this.checkPromoTimnas()
  
      // Jika promo tidak tersedia, stop proses
      // if (this.isPromoAvailable) {
      //   alert("Promo sudah tersedia saat ini.")
      //   return
      // }
      
      // Ambil produk dari backend berdasarkan prod di query
      await this.getProductAddon()

      const query = this.$route.query
      if (query.customerid && query.producttype && query.productcode) {
        this.idPelTemp = await query.customerid
        this.idPelanggan = await query.customerid
        this.optionSelected = parseInt(query.producttype)
        await this.getListAddOns()
        this.packageSelected = await this.packages.filter(item => item.durations.find(item => item.productcode === query.productcode))[0]
        this.durations = await this.packageSelected.durations
        this.durationSelected = await this.durations.filter(item => item.productcode === query.productcode)[0]
        this.bodyClass.add('scroll-hidden-mobile')
      }
    }
  }
  </script>
  